// extracted by mini-css-extract-plugin
module.exports = {"main":"disk_main__EQoLA","top":"disk_top__UNFI_","bottom":"disk_bottom__FpPfV"};